export const getPublicURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://www-dev.telia.ee';
        case 'test':
            return 'https://www-test.telia.ee';
        case 'live':
            return 'https://www.telia.ee';
    }
};
export const getSelfServiceURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://iseteenindus-dev.telia.ee';
        case 'test':
            return 'https://iseteenindus-test.telia.ee';
        case 'live':
            return 'https://iseteenindus.telia.ee';
    }
};
export const getPublicAPIBaseURL = (tier) => {
    return `${getPublicURL(tier)}/api`;
};
export const getCommonAPIBaseURL = (tier) => {
    return `${getPublicURL(tier)}/common/api`;
};
export const getTeliaShopUrl = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://pood-dev.telia.ee';
        case 'test':
            return 'https://pood-test.telia.ee';
        case 'live':
            return 'https://pood.telia.ee';
    }
};
